export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img5-b7e9acd978d7a52bcfb56c6568b8061e.png";